//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoogleMaps from '../../components/general/GoogleMaps'
import {copyToClipboard} from 'quasar'
import InventoryHandler from '@/mixins/InventoryHandler.js'

import TermsAndConditions from '@/components/mdaesports/TermsAndConditions'
import PrivacyPolicy from '@/components/mdaesports/PrivacyPolicy'
import ReturnsPolicy from '@/components/mdaesports/ReturnsPolicy'

export default {
    components: {
        GoogleMaps,
        TermsAndConditions,
        PrivacyPolicy,
        ReturnsPolicy,
    },
    data() {
        return {
            knowHowToBuyDialog: false,
            videoConfirmDialog: false,
            ccPaymentGuideDialog: false,
            acceptTerms: false,
            termsType: '',
            termsDialog: false,
            isLoading: true,
            qrDialog: false,
            whatsappNo: '66752446',
            cart: [],
            total: 0,
            seamless: true,
            cartDialog: false,
            fullName: '',
            email: '',
            contactNo: '',
            comments: '',
            selectedPickupMethod: '',
            selectedPaymentMethod: '',
            currentPointsAmount: '',
            selectedPlatform: '',
            pickupMethods: [
                {label: 'Producto digital', value: 'Producto digital'},
                {label: 'Recoger en local', value: 'Recoger en local'},
                {label: 'Entrega domicilio', value: 'Delivery'},
            ],
            paymentMethods: [
                {value: 'Yappy', slot: 'yappy'},
                {value: 'Bizum', slot: 'bizum'},
                {value: 'Paypal', slot: 'paypal'},
                {value: 'Zelle', slot: 'zelle'},
                {value: 'Visa', slot: 'visa'},
                {value: 'Mastercard', slot: 'mastercard'},
                // {value: 'Binance', slot: 'binance'},
                // {value: 'Zinly', slot: 'zinly'},
                // {value: 'ACH', slot: 'ach'},
                // {value: 'Efectivo', slot: 'cash'},
            ],
            menu: [],
            location: [],
            markers: [],
            center: {},
            address: '',
            selectedCategoryFilter: '',
            selectedSubCategoryFilter: '',
            deliveryAmount: 5,
            optionsDialog: false,
            selectedItem: null,
            videoGuideDialog: false,
            isInUsd: true,
            currencySelectDialog: true,
            discountCodes: ['kemstarmda', 'jcmda'],
            discountInput: '',
            socialFab: false,
        }
    },
    methods: {
        openCartDialog() {
            let contains = false
            for (let i = 0; i < this.cart.length; i++) {
                if (this.cart[i].name.includes('FIFA FUT COINS')) {
                    contains = true
                    break
                }
            }
            if (contains) this.knowHowToBuyDialog = true
            else this.cartDialog = true
        },
        showTermsDialog(type) {
            this.termsDialog = true
            this.termsType = type
        },
        addToCart(item) {
            if (!item.options) {
                if (this.cart.find(el => el.id == item.id)) {
                    this.cart.find(el => {
                        if (el.id == item.id) item.amount++
                    })
                } else {
                    item.amount = 1
                    this.cart.push(item)
                }
            } else {
                this.selectedItem = item
                this.optionsDialog = true
            }
            this.calculateTotal()
        },
        addItemWithOptionsToCart(selectedOption) {
            let newItem = {
                name: `${this.selectedItem.name} - ${selectedOption.label} ${
                    this.selectedItem.name == 'FIFA FUT COINS 23'
                        ? this.addFifaCoinsPromo(selectedOption.label)
                        : ''
                }`,
                amount: 1,
                price: this.isInUsd
                    ? selectedOption.price
                    : selectedOption.euroPrice,
                skipTaxes: this.selectedItem.skipTaxes ? true : false,
            }
            this.cart.push(newItem)
            this.optionsDialog = false
            this.selectedItem = null
            this.calculateTotal()
        },
        addFifaCoinsPromo(label) {
            // if (label == '300,000') return '+ 100k gratis'
            // if (label == '400,000') return '+ 100k gratis'
            if (label == '500,000') return '+ 50k gratis'
            if (label == '600,000') return '+ 50k gratis'
            if (label == '700,000') return '+ 50k gratis'
            if (label == '800,000') return '+ 50k gratis'
            if (label == '900,000') return '+ 50k gratis'
            if (label == '1,000,000') return '+ 100k gratis'
            else return ''
        },
        removeFromCart(index) {
            this.cart.splice(index, 1)
            this.calculateTotal()
            if (!this.cart.length) this.cartDialog = false
        },
        calculateTotal() {
            this.total = 0
            this.cart.forEach(item => {
                this.total += item.amount * item.price
            })
            this.total = this.total - this.calculateDiscount()
        },
        calculateDiscount() {
            if (this.discountCodes.includes(this.discountInput.toLowerCase()))
                return this.total * 0.1
            else return 0
        },
        calculateTax() {
            let chargeTax = ['Paypal', 'Visa', 'Mastercard', 'Bizum']
            if (!chargeTax.includes(this.selectedPaymentMethod)) return 0
            let total = 0
            this.cart.forEach(item => {
                if (!item.skipTaxes) total += item.amount * item.price
            })
            return Math.round(total * 0.07 * 100) / 100
        },
        calculatePaypalFee(total) {
            return Math.round(total * 0.054 * 100) / 100 + 0.3
        },
        getLocationForMessage() {
            if (this.location.length === 0) {
                if (
                    parseFloat(this.center.lat) === parseFloat(9.068463) &&
                    parseFloat(this.center.lng) === parseFloat(-79.452694)
                ) {
                    return `>> Pedir Ubicacion !!`
                } else {
                    return `https://waze.com/ul?ll=${this.center.lat},${this.center.lng}&z=10`
                }
                // let lat = parseFloat(this.center.lat)
                // let lng = parseFloat(this.center.lng)
                // if (lat < 0) lat = `+${lat}`
                // if (lng < 0) lng = `+${lng}`
            } else {
                let lat = parseFloat(this.location.lat)
                let lng = parseFloat(this.location.lng)
                if (lat === NaN || lng === NaN) return `>> Pedir Ubicacion !!`
                // if (lat < 0) lat = `+${lat}`
                // if (lng < 0) lng = `+${lng}`
                return `https://waze.com/ul?ll=${lat},${lng}&z=10`
            }
        },
        generateWhatsappMessage() {
            let message =
                'Buenas, me gustaría realizar un pedido de:%0D%0A%0D%0A'
            this.cart.forEach(item => {
                message += `(${item.amount}) - ${item.name}%0D%0A`
            })
            message += `%0D%0ANombre: ${this.fullName}`
            message += `%0D%0AEntrega: ${this.selectedPickupMethod}`
            if (this.selectedPickupMethod == 'Delivery') {
                message += `%0D%0ADirección: ${this.address}`
                message += `%0D%0AUbicación: ${this.getLocationForMessage()}`
            }
            message += `%0D%0AMetodo de pago: ${this.selectedPaymentMethod}`
            if (this.containsFifaCoinsInCart) {
                message += `%0D%0ACantidad de monedas disponibles: ${this.currentPointsAmount}`
                message += `%0D%0APlataforma: ${this.selectedPlatform}`
                message += `%0D%0ACódigo descuento: ${this.discountInput}`
            }
            message += `%0D%0ASub Total: ${
                this.isInUsd ? '$' : '€'
            }${this.total.toFixed(2)}`
            message += `%0D%0AITBMS: ${
                this.isInUsd ? '$' : '€'
            }${this.calculateTax(this.total).toFixed(2)}`
            if (this.selectedPickupMethod == 'Delivery')
                message += `%0D%0ADelivery: ${
                    this.isInUsd ? '$' : '€'
                }${this.deliveryAmount.toFixed(2)}`
            // if (this.selectedPaymentMethod == 'Paypal')
            //     message += `%0D%0AITBMS (Impuesto): ${
            //         this.isInUsd ? '$' : '€'
            //     }${this.calculatePaypalFee(this.total).toFixed(2)}`
            if (this.selectedPickupMethod != 'Delivery') {
                message += `%0D%0ATotal: ${this.isInUsd ? '$' : '€'}${
                    this.selectedPaymentMethod == 'Paypal'
                        ? (this.total + this.calculateTax(this.total)).toFixed(
                              2
                          )
                        : (this.total + this.calculateTax(this.total)).toFixed(
                              2
                          )
                }`
            } else {
                message += `%0D%0ATotal: ${this.isInUsd ? '$' : '€'}${
                    this.selectedPaymentMethod == 'Paypal'
                        ? (
                              this.total +
                              this.deliveryAmount +
                              this.calculateTax(this.total)
                          ).toFixed(2)
                        : (
                              this.total +
                              this.deliveryAmount +
                              this.calculateTax(this.total)
                          ).toFixed(2)
                }`
            }
            message = message.replace(/\+/g, '%2B')
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        sendOrder() {
            if (
                !this.fullName ||
                !this.selectedPickupMethod ||
                !this.selectedPaymentMethod ||
                !this.email ||
                !this.contactNo ||
                (this.selectedPickupMethod == 'Delivery' && !this.address) ||
                (this.containsFifaCoinsInCart && !this.selectedPlatform) ||
                (this.containsFifaCoinsInCart && !this.currentPointsAmount)
            ) {
                let errors = []
                let errMsg = 'Debes llenar los siguientes campos: '
                if (!this.fullName) errors.push('Nombre')
                if (!this.selectedPickupMethod) errors.push('Entrega')
                if (!this.selectedPaymentMethod) errors.push('Metodo de pago')
                if (!this.email) errors.push('Correo electrónico')
                if (!this.contactNo) errors.push('Número de contacto')
                if (this.selectedPickupMethod == 'Delivery' && !this.address)
                    errors.push('Dirección de entrega')
                if (this.containsFifaCoinsInCart && !this.selectedPlatform)
                    errors.push('Plataforma')
                if (this.containsFifaCoinsInCart && !this.currentPointsAmount)
                    errors.push('Cantidad actual de puntos')
                for (let i = 0; i < errors.length; i++) {
                    errMsg += errors[i]
                    if (i < errors.length - 1) errMsg += ', '
                }
                this.$q.notify({
                    message: errMsg,
                    color: 'red-7',
                    icon: 'error',
                    position: 'top',
                    progress: true,
                    classes: 'text-bold',
                    timeout: 3000,
                })
                return
            }
            window.location.href = `https://wa.me/507${
                this.whatsappNo
            }?text=${this.generateWhatsappMessage()}`
        },
        copyToClipboard(text) {
            copyToClipboard(text)
                .then(() => {
                    this.$q.notify({
                        message: `${this.selectedPaymentMethod} copiado con exito`,
                        color: 'yellow-9',
                        icon: 'check',
                        badgeColor: 'blue-7',
                        progress: true,
                        classes: 'poppins-bold',
                        timeout: 1000,
                        position: 'top',
                    })
                })
                .catch(() => {
                    // fail
                })
        },
        setMarkerPosition(event) {
            this.location = event
        },
        setNewMarkerPosition(event) {
            this.markers = [{position: event}]
            this.location = event
        },
        geolocate() {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.center = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude),
                    }
                    this.markers.push({position: this.center})
                },
                error => {
                    this.center = {
                        lat: parseFloat(9.068463),
                        lng: parseFloat(-79.452694),
                    }
                    this.markers.push({position: this.center})
                }
            )
        },
        returnLowestOptionPrice(options) {
            if (this.isInUsd) {
                let lowest = options[0].price
                options.forEach(option => {
                    if (option.price < lowest) lowest = option.price
                })
                return lowest.toFixed(2)
            } else {
                let lowest = options[0].euroPrice
                options.forEach(option => {
                    if (option.euroPrice < lowest) lowest = option.euroPrice
                })
                return lowest.toFixed(2)
            }
        },
    },
    computed: {
        showSeamless() {
            if (this.cart.length) return true
        },
        returnCategoriesOptions() {
            let categories = []
            let formattedCategories = []
            this.menu.forEach(item => {
                if (!categories.includes(item.category))
                    categories.push(item.category)
            })
            categories.forEach(cat => {
                formattedCategories.push({
                    value: cat,
                    label: cat.replace(/_/g, ' ').toUpperCase(),
                })
            })
            return formattedCategories
        },
        returnSubCategoriesOptions() {
            let subcategories = []
            let formattedSubCategories = []
            this.filterByCategory.forEach(item => {
                if (!subcategories.includes(item.subCategory))
                    subcategories.push(item.subCategory)
            })
            subcategories.forEach(subcat => {
                formattedSubCategories.push({
                    label: subcat.replace(/_/g, ' ').toUpperCase(),
                    value: subcat,
                })
            })
            return formattedSubCategories
        },
        filterByCategory() {
            let filteredProducts = []
            this.menu.forEach(product => {
                if (
                    product.category == this.selectedCategoryFilter ||
                    this.selectedCategoryFilter == ''
                )
                    filteredProducts.push(product)
            })
            return filteredProducts
        },
        filterMenuByCategoryAndSubCategory() {
            let filteredProducts = []
            if (!this.selectedCategoryFilter && !this.selectedSubCategoryFilter)
                return this.menu
            else {
                this.menu.forEach(item => {
                    if (
                        item.category.includes(this.selectedCategoryFilter) &&
                        item.subCategory.includes(
                            this.selectedSubCategoryFilter
                        )
                    )
                        filteredProducts.push(item)
                })
                return filteredProducts
            }
        },
        containsFifaCoinsInCart() {
            let contains = false
            this.cart.forEach(item => {
                if (item.name.includes('FIFA FUT COINS 23')) contains = true
            })
            return contains
        },
    },
    mixins: [InventoryHandler],
    watch: {
        selectedCategoryFilter: function() {
            this.selectedSubCategoryFilter = ''
        },
        discountInput: function() {
            this.calculateTotal()
        },
        selectedPaymentMethod: function() {
            if (
                this.selectedPaymentMethod == 'Visa' ||
                this.selectedPaymentMethod == 'Mastercard'
            )
                this.ccPaymentGuideDialog = true
        },
    },
    async mounted() {
        // this.menu = await this.getInventoryItems()
        this.geolocate()
        let m = [
            {
                name: 'FIFA FUT COINS 23',
                img: 'https://i.ibb.co/6tFVzxw/fifa-coins.jpg',
                description:
                    'Adquiere monedas para crear el equipo de tus sueños de FIFA 23 ULTIMATE TEAM sin ningún tipo de riesgo de baneo, para cualquier plataforma (XBOX, PLAYSTATION y PC)',
                category: 'recargas',
                subCategory: 'fifa',
                options: [
                    {label: '100,000', price: 14.99, euroPrice: 14.99},
                    {label: '200,000', price: 28.99, euroPrice: 28.99},
                    {label: '300,000', price: 42.99, euroPrice: 42.99},
                    {label: '400,000', price: 56.99, euroPrice: 56.99},
                    {label: '500,000', price: 70.99, euroPrice: 70.99},
                    {label: '600,000', price: 84.99, euroPrice: 84.99},
                    {label: '700,000', price: 98.99, euroPrice: 98.99},
                    {label: '800,000', price: 112.99, euroPrice: 112.99},
                    {label: '900,000', price: 126.99, euroPrice: 126.99},
                    {label: '1,000,000', price: 140.99, euroPrice: 140.99},
                ],
            },
            {
                name: 'PASS ROYALE',
                price: 6.99,
                img: 'https://i.ibb.co/GxtKfwx/pass-royale.jpg',
                description:
                    'Clash Royale Pass Royale es un paquete de contenido desbloqueable in-game por temporada, incluye ítems cosméticos y de progreso para el juego. Disponible para Android & IOS',
                category: 'recargas',
                subCategory: 'clash_royale',
            },
            {
                name: 'Clash Royale 80 Gemas',
                price: 2,
                img: 'https://i.ibb.co/y6wgrFk/80-gems.jpg',
                description:
                    'Clash Royale Gemas es un paquete de monedas in-game el cual puedes utilizar para comprar contenido exclusivo del juego CLASH ROYALE, la recarga de la misma se hace de manera directa a su cuenta de SUPER CELL en cuestiones de segundo. Disponible para Android & IOS',
                category: 'recargas',
                subCategory: 'clash_royale',
            },
            {
                name: 'Clash Royale 500 Gemas',
                price: 6,
                img: 'https://i.ibb.co/xMBzVW3/500-gems.jpg',
                description:
                    'Clash Royale Gemas es un paquete de monedas in-game el cual puedes utilizar para comprar contenido exclusivo del juego CLASH ROYALE, la recarga de la misma se hace de manera directa a su cuenta de SUPER CELL en cuestiones de segundo. Disponible para Android & IOS',
                category: 'recargas',
                subCategory: 'clash_royale',
            },
            {
                name: 'Clash Royale 1,200 Gemas',
                price: 12,
                img: 'https://i.ibb.co/6gZ5SdV/1200-gems.jpg',
                description:
                    'Clash Royale Gemas es un paquete de monedas in-game el cual puedes utilizar para comprar contenido exclusivo del juego CLASH ROYALE, la recarga de la misma se hace de manera directa a su cuenta de SUPER CELL en cuestiones de segundo. Disponible para Android & IOS',
                category: 'recargas',
                subCategory: 'clash_royale',
            },
            {
                name: 'Clash Royale 2,500 Gemas',
                price: 22,
                img: 'https://i.ibb.co/M5DSyXM/2500-gems.jpg',
                description:
                    'Clash Royale Gemas es un paquete de monedas in-game el cual puedes utilizar para comprar contenido exclusivo del juego CLASH ROYALE, la recarga de la misma se hace de manera directa a su cuenta de SUPER CELL en cuestiones de segundo. Disponible para Android & IOS',
                category: 'recargas',
                subCategory: 'clash_royale',
            },
            {
                name: 'Clash Royale 6,500 Gemas',
                price: 54,
                img: 'https://i.ibb.co/f1TX7yh/6500-gems.jpg',
                description:
                    'Clash Royale Gemas es un paquete de monedas in-game el cual puedes utilizar para comprar contenido exclusivo del juego CLASH ROYALE, la recarga de la misma se hace de manera directa a su cuenta de SUPER CELL en cuestiones de segundo. Disponible para Android & IOS',
                category: 'recargas',
                subCategory: 'clash_royale',
            },
            {
                name: 'Clash Royale 14,000 Gemas',
                price: 105,
                img: 'https://i.ibb.co/8bHczf3/14000-gems.jpg',
                description:
                    'Clash Royale Gemas es un paquete de monedas in-game el cual puedes utilizar para comprar contenido exclusivo del juego CLASH ROYALE, la recarga de la misma se hace de manera directa a su cuenta de SUPER CELL en cuestiones de segundo. Disponible para Android & IOS',
                category: 'recargas',
                subCategory: 'clash_royale',
            },
            {
                name: 'Fortnite 1000 V-Bucks',
                price: 10,
                img: 'https://i.ibb.co/CzJzSyk/1000-pavos.jpg',
                description:
                    'Fortnite V-Bucks es un paquete de monedas in-game el cual puedes utilizar para comprar diferentes artículos dentro del juego de FORNITE, la recarga de la misma se hace de manera directa a su cuenta de Epic Games en cuestiones de segundos disponible para cualquier plataforma (XBOX, PLAYSTATION, PC, NINTENDO, ANDROID & IOS)',
                category: 'recargas',
                subCategory: 'fortnite',
            },
            {
                name: 'Fortnite 2800 V-Bucks',
                price: 24,
                img: 'https://i.ibb.co/drkjrXs/2800-pavos.jpg',
                description:
                    'Fortnite V-Bucks es un paquete de monedas in-game el cual puedes utilizar para comprar diferentes artículos dentro del juego de FORNITE, la recarga de la misma se hace de manera directa a su cuenta de Epic Games en cuestiones de segundos disponible para cualquier plataforma (XBOX, PLAYSTATION, PC, NINTENDO, ANDROID & IOS)',
                category: 'recargas',
                subCategory: 'fortnite',
            },
            {
                name: 'Fortnite 5000 V-Bucks',
                price: 36,
                img: 'https://i.ibb.co/R4Q6gR0/5000-pavos.jpg',
                description:
                    'Fortnite V-Bucks es un paquete de monedas in-game el cual puedes utilizar para comprar diferentes artículos dentro del juego de FORNITE, la recarga de la misma se hace de manera directa a su cuenta de Epic Games en cuestiones de segundos disponible para cualquier plataforma (XBOX, PLAYSTATION, PC, NINTENDO, ANDROID & IOS)',
                category: 'recargas',
                subCategory: 'fortnite',
            },
            {
                name: 'Fortnite 13,500 V-Bucks',
                price: 86,
                img: 'https://i.ibb.co/XpnNq6w/13500-pavos.jpg',
                description:
                    'Fortnite V-Bucks es un paquete de monedas in-game el cual puedes utilizar para comprar diferentes artículos dentro del juego de FORNITE, la recarga de la misma se hace de manera directa a su cuenta de Epic Games en cuestiones de segundos disponible para cualquier plataforma (XBOX, PLAYSTATION, PC, NINTENDO, ANDROID & IOS)',
                category: 'recargas',
                subCategory: 'fortnite',
            },
            {
                name: 'League of Legends 10$ - RIOT GAMES PC',
                price: 11.99,
                img: 'https://i.ibb.co/njpvMPP/riot-1815.jpg',
                description:
                    '¡Sube de nivel tu experiencia en League of Legends! Entrega de código digital para que lo canjee desde su cuenta League of Legends. Disponible para: PC',
                category: 'recargas',
                subCategory: 'league_of_legends',
            },
            {
                name: 'League of Legends 25$ - RIOT GAMES PC',
                price: 26.99,
                img: 'https://i.ibb.co/Qf8Z1yZ/riot-4000.jpg',
                description:
                    '¡Sube de nivel tu experiencia en League of Legends! Entrega de código digital para que lo canjee desde su cuenta League of Legends. Disponible para: PC',
                category: 'recargas',
                subCategory: 'league_of_legends',
            },
            {
                name: 'League of Legends 50$ - RIOT GAMES PC',
                price: 52.99,
                img: 'https://i.ibb.co/cLdpYJT/riot-8400.jpg',
                description:
                    '¡Sube de nivel tu experiencia en League of Legends! Entrega de código digital para que lo canjee desde su cuenta League of Legends. Disponible para: PC',
                category: 'recargas',
                subCategory: 'league_of_legends',
            },
            {
                name: 'League of Legends 100$ - RIOT GAMES PC',
                price: 104.99,
                img: 'https://i.ibb.co/rmBdXtP/riot-13200.jpg',
                description:
                    '¡Sube de nivel tu experiencia en League of Legends! Entrega de código digital para que lo canjee desde su cuenta League of Legends. Disponible para: PC',
                category: 'recargas',
                subCategory: 'league_of_legends',
            },
            {
                name: 'Giftcard PlayStation $10',
                price: 11.99,
                img: 'https://i.ibb.co/RGnDHJx/10-ps-giftcard.png',
                description:
                    'Giftcard de PSN con valor de $25. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'Giftcard PlayStation $20',
                price: 22.99,
                img: 'https://i.ibb.co/5n56FvH/20-ps-giftcard.png',
                description:
                    'Giftcard de PSN con valor de $20. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'Giftcard PlayStation $25',
                price: 26.99,
                img:
                    'https://multimedia.bbycastatic.ca/multimedia/products/500x500/126/12677/12677654.jpg',
                description:
                    'Giftcard de PSN con valor de $25. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'Giftcard PlayStation $50',
                price: 52.99,
                img: 'https://i.ibb.co/FnSTn6H/50-ps-giftcard.png',
                description:
                    'Giftcard de PSN con valor de $50. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'Giftcard PlayStation $60',
                price: 62.99,
                img:
                    'https://http2.mlstatic.com/D_NQ_NP_733875-MLA47429803387_092021-O.jpg',
                description:
                    'Giftcard de PSN con valor de $60. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'Giftcard PlayStation $75',
                price: 77.99,
                img: 'https://i.ibb.co/zRwKXpx/psn-75.png',
                description:
                    'Giftcard de PSN con valor de $75. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'Giftcard PlayStation $100',
                price: 104.99,
                img: 'https://i.ibb.co/rx961ZL/100-ps-giftcard.png',
                description:
                    'Giftcard de PSN con valor de $100. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'PlayStation Plus - 1 mes',
                price: 12.99,
                img: 'https://i.ibb.co/Dr0Z5xn/psplus-1m.jpg',
                description:
                    'PlayStation Plus válido por 1 mes. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'PlayStation Plus - 3 meses',
                price: 27.99,
                img: 'https://i.ibb.co/4YB4xKC/psplus-3m.jpg',
                description:
                    'PlayStation Plus válido por 3 meses. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'PlayStation Plus - 12 meses',
                price: 62.99,
                img: 'https://i.ibb.co/BtH24jL/psplus-12m.jpg',
                description:
                    'PlayStation Plus válido por 12 meses. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'psn',
            },
            {
                name: 'Giftcard Nintendo $5',
                price: 5.99,
                img:
                    'https://m.media-amazon.com/images/I/71kcx+3mcmL._SL1500_.jpg',
                description:
                    'Giftcard de Nintendo con valor de $5. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Nintendo $10',
                price: 11.99,
                img:
                    'https://m.media-amazon.com/images/I/71g8qy0R8zL._SY445_.jpg',
                description:
                    'Giftcard de Nintendo con valor de $10. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Nintendo $20',
                price: 21.99,
                img:
                    'https://m.media-amazon.com/images/I/71YSvFcuK7L._SL1500_.jpg',
                description:
                    'Giftcard de Nintendo con valor de $20. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Nintendo $35',
                price: 36.99,
                img:
                    'https://m.media-amazon.com/images/I/71kYjm-EI8L._SL1500_.jpg',
                description:
                    'Giftcard de Nintendo con valor de $35. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',

                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Nintendo $45',
                price: 46.99,
                img: 'https://m.media-amazon.com/images/I/51XPfhiwKlL.jpg',
                description:
                    'Giftcard de Nintendo con valor de $45. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',

                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Nintendo $50',
                price: 52.99,
                img:
                    'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/5784/5784110_sd.jpg',
                description:
                    'Giftcard de Nintendo con valor de $50. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Nintendo $70',
                price: 71.99,
                img:
                    'https://m.media-amazon.com/images/I/714oSJ60A9L._SY679_.jpg',
                description:
                    'Giftcard de Nintendo con valor de $70. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Nintendo $99',
                price: 104.99,
                img:
                    'https://m.media-amazon.com/images/I/51x+YpqXTIL._AC_SY780_.jpg',
                description:
                    'Giftcard de Nintendo con valor de $99. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'nintendo',
            },
            {
                name: 'Giftcard Xbox $5',
                price: 5.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/3ca45092c6274acb91b6d108db61ce2e_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $5. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            {
                name: 'Giftcard Xbox $10',
                price: 11.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/5f72dd18f2254cf2a54924656290d6eb_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $10. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            {
                name: 'Giftcard Xbox $15',
                price: 16.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/43fc9a2a8e2a4bf8a71d94d724da72a5_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $15. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            // {
            //     name: 'Giftcard Xbox $20',
            //     price: 21.99,
            //     img:
            //         'https://pisces.bbystatic.com/image2/BestBuy_US/images/products/1891/1891044_sa.jpg',
            //     description:
            //         'Giftcard de Xbox con valor de $20. Exclusivo para cuentas en los Estados Unidos.',

            //     subCategory: 'xbox',
            // },
            {
                name: 'Giftcard Xbox $30',
                price: 31.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/7fbd1d9e15bd40b8b474412870e0a5b3_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $30. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            {
                name: 'Giftcard Xbox $40',
                price: 42.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/a2fd5c3369c2458886537d60df2b45de_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $40. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            {
                name: 'Giftcard Xbox $50',
                price: 52.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/5893379e583644c699eabb160f4efd46_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $50. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            // {
            //     name: 'Giftcard Xbox $60',
            //     price: 62.99,
            //     img:
            //         'https://cdn-products.eneba.com/resized-products/kV91qZzS2cn4wZ1KPKwiYQBjtPzI0nnA6Syn7AHWSv8_350x200_2x-0.jpeg',
            //     description:
            //         'Giftcard de Xbox con valor de $60. Exclusivo para cuentas en los Estados Unidos.',

            //     subCategory: 'xbox',
            // },
            {
                name: 'Giftcard Xbox $70',
                price: 72.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/628a5f48c3c345fb88c284a3d12f8905_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $70. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            {
                name: 'Giftcard Xbox $100',
                price: 104.99,
                img:
                    'https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/1564636ad707434c835493fabc918e01_Medium.jpg',
                description:
                    'Giftcard de Xbox con valor de $100. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'xbox',
            },
            {
                name: 'Spotify Premium - 3 Meses',
                price: 32.99,
                img: 'https://i.ibb.co/h9NsNDR/spotify-3meses.jpg',
                description:
                    'Cuentas Spotify en Plan Premium por tiempo de vigencia de 3 meses predeterminado desde efectuada la compra. (Sin afiliar tarjetas de crédito/débito).',
                category: 'codigos_digitales',
                subCategory: 'spotify',
            },
            {
                name: 'Spotify Premium - 12 Meses',
                price: 104.99,
                img: 'https://i.ibb.co/bRvZFmL/spotify-12meses.jpg',
                description:
                    'Cuentas Spotify en Plan Premium por tiempo de vigencia de 12 meses predeterminado desde efectuada la compra (Sin afiliar tarjetas de crédito/débito).',
                category: 'codigos_digitales',
                subCategory: 'spotify',
            },
            {
                name: 'Netflix - 3 Meses',
                price: 32.99,
                img: 'https://i.ibb.co/PZC72pY/netflix-3meses.jpg',
                description:
                    'Cuentas NETFLIX en Plan Premium por tiempo de vigencia de 3 meses predeterminado desde efectuada la compra (Sin afiliar tarjetas de crédito/débito).',
                category: 'codigos_digitales',
                subCategory: 'netflix',
            },
            {
                name: 'Netflix - 12 Meses',
                price: 104.99,
                img: 'https://i.ibb.co/jfhy3YW/netflix-12meses.jpg',
                description:
                    'Cuentas NETFLIX en Plan Premium por tiempo de vigencia de 12 meses predeterminado desde efectuada la compra (Sin afiliar tarjetas de crédito/débito).',
                category: 'codigos_digitales',
                subCategory: 'netflix',
            },
            {
                name: 'Giftcard Google Play $5',
                price: 8,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/5-google-play-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $5. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'google',
            },
            {
                name: 'Giftcard Google Play $10',
                price: 12,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/10-google-play-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $10. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'google',
            },
            {
                name: 'Giftcard Google Play $15',
                price: 17,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/15-google-play-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $15. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'google',
            },
            {
                name: 'Giftcard Google Play $25',
                price: 27,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/25-google-play-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $25. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'google',
            },
            {
                name: 'Giftcard Google Play $50',
                price: 53,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/50-google-play-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $50. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'google',
            },
            {
                name: 'Giftcard Google Play $100',
                price: 105,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/100-google-play-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $100. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'google',
            },
            {
                name: 'Giftcard iTunes $5',
                price: 8,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/5-itunes-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $5. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'itunes',
            },
            {
                name: 'Giftcard iTunes $10',
                price: 12,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/10-itunes-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $10. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'itunes',
            },
            {
                name: 'Giftcard iTunes $15',
                price: 17,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/5-itunes-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $15. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'itunes',
            },
            {
                name: 'Giftcard iTunes $25',
                price: 27,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/25-itunes-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $25. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'itunes',
            },
            {
                name: 'Giftcard iTunes $50',
                price: 53,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/50-itunes-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $50. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'itunes',
            },
            {
                name: 'Giftcard iTunes $100',
                price: 105,
                img:
                    'https://www.thecardcloset.com/static/img/gift-cards/100-itunes-digital-gift-card-email-delivery-2x.png',
                description:
                    'Giftcard de Google Play con valor de $100. Exclusivo para cuentas en los Estados Unidos.',
                category: 'codigos_digitales',
                subCategory: 'itunes',
            },
            {
                name: 'PlayStation 5 - Digital',
                price: 650,
                img: 'https://i.ibb.co/KGwgjzY/ps5-digital.jpg',
                description: 'PlayStation 5 Versión digital.',
                category: 'consolas',
                subCategory: 'playstation',
            },
            {
                name: 'PlayStation 5 - Disco',
                price: 750,
                img: 'https://i.ibb.co/pPn2hK3/ps5-disk.jpg',
                description: 'PlayStation 5 Versión disco.',
                category: 'consolas',
                subCategory: 'playstation',
            },
            {
                name: 'Xbox Series S',
                price: 650,
                img: 'https://i.ibb.co/TMMPFwm/xbox-s.jpg',
                description: 'Xbox Series S.',
                category: 'consolas',
                subCategory: 'xbox',
            },
            {
                name: 'Xbox Series X',
                price: 750,
                img: 'https://i.ibb.co/r0PxpXj/xbox-x.jpg',
                description: 'Xbox Series X.',
                category: 'consolas',
                subCategory: 'xbox',
            },
            {
                name: 'Control PS4 - Azul',
                price: 50.99,
                img: 'https://i.ibb.co/JxTqKQx/control-ps4-blue.jpg',
                description: 'Control para PlayStation 4 color azul',
                category: 'accesorios',
                subCategory: 'ps4',
            },
            {
                name: 'Control PS4 - Cyan',
                price: 50.99,
                img: 'https://i.ibb.co/qJJLg0d/control-ps4-cyan.jpg',
                description: 'Control para PlayStation 4 color cyan',
                category: 'accesorios',
                subCategory: 'ps4',
            },
            {
                name: 'Control PS4 - Naranja',
                price: 50.99,
                img: 'https://i.ibb.co/BVsV7Jc/control-ps4-orange.jpg',
                description: 'Control para PlayStation 4 color naranja',
                category: 'accesorios',
                subCategory: 'ps4',
            },
            {
                name: 'Control PS4 - Negro',
                price: 50.99,
                img: 'https://i.ibb.co/xH6jBSC/control-ps4-black.jpg',
                description: 'Control para PlayStation 4 color negro',
                category: 'accesorios',
                subCategory: 'ps4',
            },
            {
                name: 'Control PS4 - Camo',
                price: 50.99,
                img: 'https://i.ibb.co/q71zNRJ/control-ps4-camo.jpg',
                description: 'Control para PlayStation 4 color negro',
                category: 'accesorios',
                subCategory: 'ps4',
            },
        ]
        this.menu = m
        let id = 0
        this.menu.forEach(item => {
            item.id = id
            id++
        })
        this.isLoading = false
    },
}
